import { List, ListItem, Typography } from '@mui/material';
import { PortableText } from '@portabletext/react';

interface ContentProps {
  content: any;
}

export function Content({ content }: ContentProps) {
  return (
    <PortableText
      value={content}
      components={{
        block: {
          h1: ({ children }) => <Typography variant="h1">{children}</Typography>,
          h2: ({ children }) => <Typography variant="h2">{children}</Typography>,
          h3: ({ children }) => <Typography variant="h3">{children}</Typography>,
          h4: ({ children }) => <Typography variant="h4">{children}</Typography>,
          h5: ({ children }) => <Typography variant="h5">{children}</Typography>,
          h6: ({ children }) => <Typography variant="h6">{children}</Typography>,
          normal: ({ children }) => <Typography>{children}</Typography>,
        },
        list: ({ children }) => <List>{children}</List>,
        listItem: ({ children }) => <ListItem>{children}</ListItem>,
      }}
    />
  );
}
